<template>
    <div>
        AUTH
        <span v-if="$auth.ready()">
            <p>check:{{$auth.check()}}</p>
            <p>user:{{$auth.user()}}</p>
        </span>
        <span v-if="hasError">ERROR</span>
    </div>
</template>

<script>
export default {
    name: 'login-manual',
    data: () => ({
        email: '',
        password: '',
        hasError: false,
    }),

    created() {
        this.$auth.ready(function () {
            this.setToken();
        });
    },

    methods: {
        setToken() {
            let token = this.$route.params.authToken;
            if (!token) {
                this.hasError = true;

                return;
            }

            window.axios.post('users/token/attach', { token: token })
                .then(() => this.$auth.fetch())
                .then(() => {
                    let routeName = this.$route.params.routeName;
                    if (routeName) {
                        this.$router.push({ name: routeName });
                        return;
                    }
                    this.$router.push({ name: 'dashboard' });
                })
                .catch(() => {
                    this.hasError = true;
                });
        },

        login() {
            this.$auth.login({
                context: this,
                params: {
                    email: this.email,
                    password: this.password
                },
                success: function () {
                    this.$router.push({ name: 'dashboard' });
                },
                error: function () {
                    this.hasError = true;
                },
            }).catch(() => {
                this.hasError = true;
            });
        },

    }
}
</script>
